import { memo, useMemo } from 'react';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { getDownloadedFileName } from 'src/utils/getDownloadedFileName';
import { DownloadIcon } from 'src/modules/common/icons/DownloadIcon.tsx';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { Button } from 'src/common/Button/Button.tsx';

type Props = {
    xmlString: string;
    isMobile?: boolean;
}

export const ValveDownloadXMLButton = memo(({
    xmlString,
    isMobile,
}: Props) => {
    const downloadXMLUrl = useMemo(() => {
        const blob = new Blob([xmlString], { type: 'application/xml' });

        return URL.createObjectURL(blob);
    }, [xmlString]);

    return (
        <Button
            as="a"
            href={downloadXMLUrl}
            download={getDownloadedFileName('mvef')}
            size={isMobile ? 'md' : 'sm'}
            kind="tertiary"
            icon={(
                <div className="vss-checkout-page__navigation-icon">
                    <DownloadIcon/>
                </div>
            )}
        >
            <I18n messageId={MESSAGES.revitPluginDownloadXMLButton}/>
        </Button>
    );
});
